import {useTranslation} from 'react-i18next';
import {Clock4Icon} from 'lucide-react';
import {AUTH_INIT_MODELS} from '@chekin/core';
import {useLayoutMode} from 'hooks/useLayoutMode';
import {useIdleDetector} from 'components/sessions/useIdleDetector';
import {useChekinSDK} from 'context/ChekinSDK';
import {usePath, useTimer} from 'hooks';
import {useReservation} from 'context/reservation';
import {StatusModal, StatusModalStates} from '@chekin/shared';
import {Button, useModalControls} from '@chekin/guestapp-ui-kit';
import {closeSession} from 'components/sessions/utils';
import {useLocation, useNavigate} from 'react-router-dom';
import {PATHS} from 'routes/constants';

const LIMIT = 15;

function ExpireSessionCloseModal() {
  const layoutMode = useLayoutMode();
  const {t} = useTranslation('kiosko');
  const {isOpen, openModal, closeModal} = useModalControls();
  const {modelName} = useChekinSDK();
  const {reservationId} = useReservation();
  const {getFullPath} = usePath();
  const navigate = useNavigate();
  const location = useLocation();
  const enabled =
    !location.pathname.includes(PATHS.searchReservation.welcomeScreen) &&
    layoutMode === 'kiosko';

  const {count} = useTimer({
    initialTime: LIMIT,
    onFinish: () => {
      if (modelName === AUTH_INIT_MODELS.housing) {
        closeModal();
        navigate(getFullPath(PATHS.searchReservation.welcomeScreen));
        return;
      }

      closeSession(reservationId, PATHS.searchReservation.welcomeScreen);
    },
    enabled: isOpen,
  });

  useIdleDetector({
    enabled,
    onIdle: openModal,
  });

  return (
    <StatusModal state={StatusModalStates.IDLE} open={isOpen}>
      <div className="flex flex-col gap-14 mb-[112px] px-11 items-center">
        <Clock4Icon size="78" color="#777E91" />
        <div className="flex flex-col gap-5">
          <div className="font-semibold leading-14 text-kiosko-l text-primary">
            {t('your_session_is_about_to_expire')}
          </div>
          <div className="text-kiosko-m leading-14">
            {t('for_security_this_session_will_end_due_to_inactivity')}
          </div>
        </div>
        <div className="flex flex-col items-center">
          <div className="text-[75px] font-semibold leading-14">{count}</div>
          <div className="text-kiosko-m leading-14">{t('seconds_remaining')}</div>
        </div>
        <Button onClick={closeModal} size="md" className="m-auto gap-[18px]">
          {t('keep_session_open')}
        </Button>
      </div>
    </StatusModal>
  );
}

export {ExpireSessionCloseModal};
